import { createContext, useContext } from 'react';

// A row drawn above its own expanded card on a phone, where the row's title is the
// card's heading
export const PhoneHostRowContext = createContext(false);

export const usePhoneHostRow = () => useContext(PhoneHostRowContext);

// A row drawn at a sidebar's or a phone's width, where its link shows the icon
// alone so the title keeps room beside the status
export const NarrowHostRowContext = createContext(false);

export const useNarrowHostRow = () => useContext(NarrowHostRowContext);
